import './ModalRisk.scss'
import React, { useState, useEffect } from 'react'
import { Descriptions, Button, Table, Icon, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { getClientDetailPromise, getClientHistoryMonitoreoPromise } from '../../promises'
import { camelizerHelper } from '../../../../helpers'
import apiConfig from '../../../../config/api'
import Plot from "react-plotly.js";
import moment from 'moment';

const ModalRisk = ({ record }) => {
  const { t } = useTranslation('translations')

  const [clientHistory, setClientHistory] = useState([])
  const [clientHistoryChart, setClientHistoryChart] = useState([])
  const [ubos, setUbos] = useState([])

  const latestHistoryRisk = React.useMemo(() => {
    if (!clientHistory || clientHistory.length === 0) return record?.amlStatus

    let latest = null
    let latestTs = -Infinity

    for (const h of clientHistory) {
      const rawDate = h?.creationDate ?? h?.day
      const ts = rawDate ? new Date(rawDate).getTime() : NaN
      if (!Number.isFinite(ts)) continue
      if (ts > latestTs) {
        latestTs = ts
        latest = h
      }
    }

    return latest?.risk ?? record?.amlStatus
  }, [clientHistory, record?.amlStatus])

  useEffect(() => {
    if (record.id !== null && record.id !== undefined) {
      getClientDetailPromise(record.id).then(response => {
          if (response.entity !== null && response.entity.propietarios !== null) {
            setUbos(getRiskUbos(response))
          }
        })
      getClientHistoryMonitoreoPromise(record.id).then(response => {
          setClientHistory(response)
          let historyChart = []
          let last = null
          for(let i=0;i<response.length;i++) {
            let hist = response[i]
            const date = new Date(hist.creationDate);
            hist.date = date
            let add = false
            if(last === null || response.length < 10) add = true
            else {
              const hhDiff = (last.date.getTime() - date.getTime()) / 1000 / 3600
              if(hhDiff >= (7*24)) add = true
            }
            if(add) {
              last = hist
              historyChart.push(hist)
            }
          }
          setClientHistoryChart(historyChart.reverse())
          //setClientHistoryChart(historyChart)
        })
    }
  }, [])

  const labelFormatterPlotly = (e) => {
    switch (e) {
      case 0: return '0'
      case 1: return '1'
      case 2: return '2'
      case 3: return '3'
      case 4: return '4'
      default: return ''
    }
  }

  const xlabelFormatterPlotly = (e) => {
    switch (e) {
      case 0: return '0'
      case 1: return '1'
      case 2: return '2'
      case 3: return '3'
      case 4: return '4'
      default: return ''
    }
  }


  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const getValueRisk = (risk) => {
    if (risk !== null) {
      if (risk === 'GREEN') return 0
      else if (risk === 'YELLOW') return 1
      else if (risk === 'ORANGE') return 2
      else if (risk === 'RED') return 3
      else if (risk === 'BLACK') return 4
    }
    return 0
  }

  const getColorByRisk = (risk) => {
    if (risk === null || risk === undefined) return '#999'
    if (risk === 'GREEN') return '#598756'
    else if (risk === 'YELLOW') return '#fcdc6b'
    else if (risk === 'ORANGE') return '#FE9F0C'
    else if (risk === 'RED') return '#d9534f'
    else if (risk === 'BLACK') return '#4C4C4C'
  }

  const getRiskName = (risk) => {
    if (risk === null || risk === undefined) return t('messages.aml.unassigned')
    if (risk === 'GREEN') return t('messages.aml.risk.N')
    else if (risk === 'YELLOW') return t('messages.aml.low')
    else if (risk === 'ORANGE') return t('messages.aml.medium')
    else if (risk === 'RED') return t('messages.aml.high')
    else if (risk === 'BLACK') return t('messages.aml.critical')
  }

  const downloadReportRisk = (pdfFile) => {
    window.open(apiConfig.url + '/ubo/getPDFUboFinder?path=' + pdfFile)
  }

  const getRiskUbos = (data) => {
    let rows = []
    if (data.entity !== null) {
      if (data.entity.amlStatus !== null && data.entity.amlStatus !== 'GREEN') {
        data.entity.type = data.clCliente.type
        rows.push(data.entity)
      }
      for (let i = 0; i < data.entity.propietarios.length; i++) {
        if (data.entity.propietarios[i].amlStatus !== null && data.entity.propietarios[i].amlStatus !== 'GREEN') {
          rows.push(data.entity.propietarios[i])
        }
      }
    }
    return rows
  }

  const getBasesAML = (bases) => {
    if (bases !== null) return bases.join()
  }

  const riskHistoryColumns = [
    {
      title: t('messages.aml.date'),
      dataIndex: 'day',
      width: 200
    }, {
      title: t('messages.aml.modalAlert.riskType'),
      dataIndex: 'riskType',
      width: 200,
      render: (text) => {
        if (text === 'USER') return t('messages.aml.assignedRisk')
        return t('messages.aml.amlRisk')
      }
    }, {
      title: t('messages.aml.risk'),
      dataIndex: 'risk',
      width: 200,
      render: (text, record) => {
        return <div className={text === null || text === undefined ? 'onboarding risk-GRAY' : 'onboarding risk-' + text} />
      }
    }, {
      title: t('messages.aml.databases'),
      dataIndex: 'basesAml',
      render: (text, record) => {
        return text && text.join(',')
      }
    }, {
      title: t('messages.aml.modalAlert.sectionAlert'),
      dataIndex: 'alert',
      render: (text, record) => {
        return text && 
          <Tooltip title={t('messages.aml.modalAlert.sectionAlert')}>
            <Icon type="exclamation-circle" theme="twoTone" twoToneColor="#f5222d" size="small" />
          </Tooltip>
      }
    }

  ]

  const getTypeRelated = (type) => {
    if(type === "REP_LEGAL") return t('messages.aml.repLegal')
    else if(type === "DIRECTOR") return "Director"
    else if(type === "GERENTE_GENERAL") return "Gerente"
    else if(type === "EJ_PRINCIPAL") return "Ejecutivo Principal"
    else if(type === "AVAL") return "Aval o Coaval"
    else if(type === "APODERADO") return "Apoderado"
    else return type
  }

  const riskTableColumns = [
    {
      title: t('messages.aml.type'),
      dataIndex: 'type',
      width: 100,
      render: (text, record) => {
        if (text === 'Entity') {
          return t('messages.aml.entity')
        } else if(record.origenMallaPropiedad === 'CLIENTE'){
          return "UBO"
        }else {
          return getTypeRelated(record.origenMallaPropiedad)
        }
      }
    },
    {
      title: t('messages.aml.rut'),
      dataIndex: 'rut',
      width: 100,
      render: (text, record) => {
        if (record.pais === 'NACIONAL') {
          return text
        }
      }
    },
    {
      title: t('messages.aml.name'),
      dataIndex: 'name',
      width: 220,
      render: (text) => camelizerHelper(text)
    },
    {
      title: t('messages.aml.risk'),
      dataIndex: 'amlStatus',
      width: 70,
      render: (text) => <div className={'risk risk-' + text} />
    },
    {
      title: t('messages.aml.module'),
      dataIndex: 'baseAml',
      width: 150
    },
    {
      title: t('messages.aml.download'),
      dataIndex: 'pdfFile',
      width: 80,
      render: (text) => <Button type="primary" icon="file-pdf" size="small" onClick={(e) => downloadReportRisk(text)} />
    }
  ]

  return (
    <div className="modal-risk">
      { record.id !== null && record.id !== undefined &&
        <Descriptions layout="vertical" size="small" column={2} bordered>
          <Descriptions.Item label={t('messages.aml.rut')}>
            {record.rut}
          </Descriptions.Item>
          <Descriptions.Item label={t('messages.aml.name')}>
            {camelizerHelper(record.nombre)}
          </Descriptions.Item>
          <Descriptions.Item label={t('messages.aml.type')}>
            {record.type}
          </Descriptions.Item>
          <Descriptions.Item label={t('messages.aml.risk')}>
            <div className={'onboarding risk-' + latestHistoryRisk} />
          </Descriptions.Item>
          {record.pdfFile !== null && record.pdfFile !== '' &&
            <Descriptions.Item label={t('messages.aml.downloadPDF')}>
              <Button type="primary" icon="file-pdf" onClick={(e) => downloadReportRisk(record.pdfFile)} />
            </Descriptions.Item>
          }
          {record.pdfFile !== null && record.pdfFile !== '' &&
            <Descriptions.Item label={t('messages.aml.databases')}>
              {getBasesAML(record.basesAml)}
            </Descriptions.Item>
          }
          {ubos !== null && ubos.length > 0 &&
            <Descriptions.Item label={t('messages.aml.databases')} span={2}>
              {getBasesAML(record.basesAml)}
            </Descriptions.Item>
          }
          {ubos !== null && ubos.length > 0 &&
            <Descriptions.Item label={t('messages.aml.detail')} span={2}>
              <Table dataSource={ubos} columns={riskTableColumns} pagination={false} size='small' />
            </Descriptions.Item>
          }
          <Descriptions.Item label={t('messages.aml.modalRisk.alertHistory')} span={2}>
            <div className="risk-chart">
              <div className="risk-chart-inner">
                <Plot
                  data={
                    [
                      {
                        x: clientHistoryChart.map(obj=>{
                          return obj.day
                        }),
                        y: clientHistoryChart.map(obj=>getValueRisk(obj.risk)),
                        hovertemplate: '%{text}<extra></extra>',
                        text : clientHistoryChart.map(obj=>{
                          return '<b>'+obj.day + ': '+getRiskName(obj.risk)+'</b>'
                        }),
                        type: 'scatter',
                        line: {
                          shape: 'spline',
                          smoothing: '1.2',
                          width: 2,
                          color: 'rgb(109 120 174)',
                        },

                        mode: 'lines+markers',
                        marker: {
                          color: clientHistoryChart.map(detail=>getColorByRisk(detail.risk)),
                          size: 7,
                        },
                      },
                    ]
                  }

                  layout=
                  {{
                    hovermode: 'closest',
                    showlegend: false,
                    margin: {
                      l: 25,
                      r: 20,
                      b: 60,
                      t: 0,
                    },
                    width: 800,
                    height: 250,
                    // title: '',
                    paper_bgcolor: 'rgba(0,0,0,0)',
                    plot_bgcolor: 'rgba(0,0,0,0)',
                    autoscale: false,
                    xaxis: {
                      type:'array',
                      tickvals: clientHistoryChart.map(obj=>{
                        return obj.day
                      }),
                      ticktext: clientHistoryChart.map(obj=>{
                        return capitalizeFirstLetter(moment(obj.day,'YYYY-MM-DD').format('MMM DD YYYY'))
                      }),
                      showgrid: false,
                      showticklabels: true,
                      tickfont: {
                        family: 'Arial, sans-serif',
                        size: 9,
                        color: 'rgb(103 103 103)'
                      },
                      ticklen: 4,
                      tickwidth: 1,
                      tickcolor: "#000",
                      dtick: 1,
                      // showline: true,
                      // linewidth:2
                    },
                    yaxis: {
                      rangemode:'tozero',
                      range:[0, 5],
                      // type:'linear',
                      title: t('messages.aml.risk'),
                      titlefont: {
                        family: 'Arial, sans-serif',
                        size: 10,
                        color: 'rgb(103 103 103)'
                      },
                      showticklabels: true,
                      tickfont: {
                        family: 'Arial, sans-serif',
                        size: 10,
                        color: 'rgb(103 103 103)'
                      },
                      // autotick:false,
                      // tick0:0,
                      // dtick:1,
                      ticklen: 4,
                      tickwidth: 1,
                      tickcolor: "#000",
                      tickmode: 'array',
                      tickvals: [0,1,2,3,4],
                      ticktext: [0,1,2,3,4].map(i => labelFormatterPlotly(i)),
                      showgrid: true,
                      gridcolor: 'rgb(187 187 187)',
                      // showline: true,
                      // linewidth:2
                      // zeroline:true
                    }

                  }}

                  config={{
                    displayModeBar: false, // this is the line that hides the bar.
                  }}
                >
                </Plot>
              </div>
            </div>
            <br />
            <Table dataSource={clientHistory} columns={riskHistoryColumns} pagination={true} size='small' />
          </Descriptions.Item>
        </Descriptions>
      }
    </div>
  )
}
export default ModalRisk;